import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { PatientVisitTypeEnum } from '@models/patientVisit'

import styles from './QueueNodePatientVisitType.module.scss'

type Props = {
  patientVisitType: PatientVisitTypeEnum
}

const QueueNodePatientVisitType: FC<Props> = ({ patientVisitType }) => {
  const getBadgeClass = () => {
    switch (patientVisitType) {
      case PatientVisitTypeEnum.CONSULTATION:
        return styles.badge_consultation
      case PatientVisitTypeEnum.TAKE_MEDICINE:
        return styles.badge_take_medicine
      case PatientVisitTypeEnum.VACCINATION:
        return styles.badge_vaccination
      case PatientVisitTypeEnum.HEALTH_SCREENING:
        return styles.badge_health_screening
      case PatientVisitTypeEnum.MEDICAL_CHECKUP:
        return styles.badge_medical_checkup
      default:
        return ''
    }
  }

  return (
    <div className={`badge ${getBadgeClass()}`}>
      <FormattedMessage id={`enum.patient_visit_type.${patientVisitType.toLowerCase()}`} />
    </div>
  )
}

export default QueueNodePatientVisitType
